import { render, staticRenderFns } from "./PdfFileView.vue?vue&type=template&id=417bb8d3&scoped=true&"
import script from "./PdfFileView.vue?vue&type=script&lang=js&"
export * from "./PdfFileView.vue?vue&type=script&lang=js&"
import style0 from "./PdfFileView.vue?vue&type=style&index=0&id=417bb8d3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417bb8d3",
  null
  
)

export default component.exports